import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

import { PaginationSortField } from '@pflegia/types/common/job-position/pagination-sort-field';
import { useJobListSortStore } from '@pflegia/ui/hooks/use-sort';
import { JOBS } from '@pflegia/ui/pflegia/constants/routes';
import { normalizeJobsParams } from '@pflegia/util/common/normalize-jobs-params';

interface CityCardProps {
  city: string;
  fallbackImageSrc?: string;
  imageSrc: string;
}

const CityCard = ({ city, fallbackImageSrc, imageSrc }: CityCardProps) => {
  const { setSort } = useJobListSortStore();
  const [currentSrc, setCurrentSrc] = useState<string>(imageSrc);

  return (
    <Link
      key={city}
      href={`${JOBS}/${normalizeJobsParams(city)}`}
      onClick={() => setSort(PaginationSortField.Salary)}
      className='flex flex-col items-center justify-center overflow-hidden rounded-2xl shadow-2xl transition-transform duration-200 ease-in hover:scale-105 hover:ease-out'>
      <Image
        alt=''
        className='h-38.75 w-full object-cover'
        src={currentSrc}
        height={155}
        width={373}
        onError={() => fallbackImageSrc && setCurrentSrc(fallbackImageSrc)}
      />
      <p className='mt-4 mb-5 text-2xl'>{city}</p>
    </Link>
  );
};

export default CityCard;
